import { useGetApiChatCreditKeyGetValidCredit, useGetApiChatCreditKeyListByUserId } from "@/API";
import { PageTitle } from "@/Components/PageTitle";
import { TimestampToDate } from "@/Helpers/DateHelper";
import { Progress, Tooltip, Text } from "@mantine/core";
import { DataTable } from "mantine-datatable";

export function ChatCreditKeyPage() {
    const list = useGetApiChatCreditKeyListByUserId()
    const validCredit = useGetApiChatCreditKeyGetValidCredit()
    return <>
        <PageTitle text="聊天點數" />
        <br />
        <Text mb="md">
            剩餘有效點數 : {validCredit.data?.data}
        </Text>
        {list.isSuccess && <>
            <DataTable
                minHeight={(list.data.data.results?.length ?? 0) > 0 ? 0 : 150}
                noRecordsText="沒有儲值金鑰"
                withRowBorders={false}
                columns={[
                    { accessor: "id", width: 300 },
                    { accessor: "startTimestamp", width: 200, title: "開始時間", render: (data) => (TimestampToDate(data.startTimestamp ?? 0)).toLocaleString() },
                    { accessor: "endTimestamp", width: 200, title: "到期時間", render: (data) => (TimestampToDate(data.endTimestamp ?? 0)).toLocaleString() },
                    {
                        accessor: "credit", width: 150, title: "聊天點數", render: (data) => <>
                            <Tooltip label={`${data.credit}/${data.totalCredit}`}>
                                <Progress.Root size="xl">
                                    <Progress.Section value={(data.credit ?? 0) / (data.totalCredit ?? 1) * 100}>
                                        <Progress.Label>{data.credit}/{data.totalCredit}</Progress.Label>
                                    </Progress.Section>
                                </Progress.Root></Tooltip>
                        </>
                    },
                    {
                        accessor: "description", title: "註記", render: (data) => <Tooltip style={{ whiteSpace: "pre-wrap" }} label={data.description} multiline><Text variant="text" w={100} fw={300} truncate="end">{data.description}</Text></Tooltip>
                    },
                ]}
                records={list.data.data.results}
            />
        </>
        }
    </>
}